// Lets a whole table row (or card) open something, usually a player's profile.
// Clicks on the row's own controls (buttons, links, checkboxes, dropdowns) keep
// doing their own thing, and selecting text in a row doesn't open anything.
const CONTROLS = 'button, a, input, select, textarea, label, [role="button"]';

export const openOnRowClick = (open) => (event) => {
  if (event.target.closest(CONTROLS)) return;
  if (window.getSelection?.().toString()) return;
  open();
};
